import "./App.css";
import Form from "./Form";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import StudentDetails from "./studentDetails";
import FeeReceipt from "./Receipt";
import LoginPage from "./Login";
import React, { useEffect, useState } from "react";
import StudentFeeReceipt from "./studentReceipt";
import AdmissionPage from "./AdmissionPage";

export default function App() {
  const [admissionDetails, setAdmissionDetails] = useState(null);
  const [studentData, setStudentData] = useState(null); // State to hold student data
  useEffect(() => {
    sessionStorage.getItem("loggedIn");
  }, []);

  const handleProceed = async (details) => {
    console.log("App.js called");
    setAdmissionDetails(details);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/fetch-student-data/${details.admissionNumber}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch student data");
      }
      const result = await response.json();
      setStudentData(result.data); // Set the fetched student data
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/ladyirwin"
          element={<AdmissionPage onProceed={handleProceed} />}
        />
        <Route
          path="/ladyirwin/form"
          element={
            <Form
              admissionDetails={admissionDetails}
              studentData={studentData}
            />
          }
        />
        <Route path="/ladyirwin/student-details" element={<StudentDetails />} />
        <Route
          path="/ladyirwin/fee-receipt/:transaction_id"
          element={<StudentFeeReceipt />}
        />
        <Route
          path="/ladyirwin/admin/fee-receipt/:transaction_id"
          element={<FeeReceipt />}
        />
        <Route path="/ladyirwin/login" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
}
